import { render, staticRenderFns } from "./MarketplaceWizard.vue?vue&type=template&id=d07ae74e&scoped=true&"
import script from "./MarketplaceWizard.vue?vue&type=script&lang=js&"
export * from "./MarketplaceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07ae74e",
  null
  
)

export default component.exports